if (window.__collectionList5Initialized) {
  console.log('detail-hover already initialized, skipping');
} else {
  window.__collectionList5Initialized = true;

  const n = window.matchMedia("(max-width: 768px)").matches,
        l = document.querySelectorAll(".detail-hover__trigger"),
        a = document.querySelectorAll(".detail-hover__image-container");
  let i = null;
  
  const s = e => {
    l.forEach(c => c.classList.remove("xo-active"));
    a.forEach(c => c.classList.remove("xo-active", "zoom-in"));
    const t = l[e],
          o = a[e];
    t && t.classList.add("xo-active");
    o && o.classList.add("xo-active", "zoom-in");
  };
  
  l.forEach((e, t) => {
    if (n) {
      e.addEventListener("click", o => {
        o.preventDefault();
        if (i) {
          clearTimeout(i);
          i = null;
          window.location.href = e.getAttribute("data-collection-link") || "#";
        } else {
          i = setTimeout(() => {
            s(t);
            i = null;
          }, 300);
        }
      });
    } else {
      e.addEventListener("mouseenter", () => s(t));
    }
  });
}